import { reportNavType } from '@edulastic/constants/const/report'

const {
  ASSESSMENT_SUMMARY,
  PEER_PERFORMANCE,
  QUESTION_ANALYSIS,
  RESPONSE_FREQUENCY,
  PERFORMANCE_BY_STANDARDS,
  PERFORMANCE_BY_STUDENTS,
} = reportNavType

const prefix = '/author/reports'

/**
 * SAR path prefixes. Trailing `/` avoids prefix collisions
 * (e.g. assessment-summary vs assessment-summary-extra).
 * Add other report family path lists here as Report Context expands.
 */
export const SAR_REPORT_PATHS = [
  `${prefix}/${ASSESSMENT_SUMMARY}/`,
  `${prefix}/${PEER_PERFORMANCE}/`,
  `${prefix}/${QUESTION_ANALYSIS}/`,
  `${prefix}/${RESPONSE_FREQUENCY}/`,
  `${prefix}/${PERFORMANCE_BY_STANDARDS}/`,
  `${prefix}/${PERFORMANCE_BY_STUDENTS}/`,
]

/** Generic path matcher for report route families (SAR, DW, etc.). */
export const isReportPath = (pathname = '', reportPaths = []) =>
  reportPaths.some((path) => pathname.startsWith(path))
